import { jsx } from "react/jsx-runtime";
import { c } from "react/compiler-runtime";
import "react";
import { Box } from "@vk-hr-tek/ui/Box";
import { Tooltip } from "@vk-hr-tek/ui/Tooltip";
import { MultipleAutocompleteInput } from "../../MultipleAutocompleteInput/index.js";
const PositionsInput = (t0)=>{
    const $ = c(10);
    const { name, hasPositions, loading, loadPositions, renderTags, onChange } = t0;
    const t1 = !hasPositions;
    let t2;
    if ($[0] !== loadPositions || $[1] !== loading || $[2] !== name || $[3] !== onChange || $[4] !== renderTags || $[5] !== t1) {
        t2 = /*#__PURE__*/ jsx(Box, {
            children: /*#__PURE__*/ jsx(MultipleAutocompleteInput, {
                type: "load",
                disabled: t1,
                loading: loading,
                testId: "test-id-positions-multiple-autocomplete-input",
                name: name,
                label: "\u0414\u043E\u043B\u0436\u043D\u043E\u0441\u0442\u044C",
                placeholder: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0434\u043E\u043B\u0436\u043D\u043E\u0441\u0442\u044C",
                loadItems: loadPositions,
                renderTags: renderTags,
                onChange: onChange
            })
        });
        $[0] = loadPositions;
        $[1] = loading;
        $[2] = name;
        $[3] = onChange;
        $[4] = renderTags;
        $[5] = t1;
        $[6] = t2;
    } else t2 = $[6];
    let t3;
    if ($[7] !== hasPositions || $[8] !== t2) {
        t3 = /*#__PURE__*/ jsx(Box, {
            display: "flex",
            flexDirection: "column",
            children: /*#__PURE__*/ jsx(Tooltip, {
                title: "\u041D\u0435\u0442 \u0434\u043E\u043B\u0436\u043D\u043E\u0441\u0442\u0435\u0439 \u0432 \u0441\u043F\u0438\u0441\u043A\u0435",
                placement: "right",
                disabled: hasPositions,
                children: t2
            })
        });
        $[7] = hasPositions;
        $[8] = t2;
        $[9] = t3;
    } else t3 = $[9];
    return t3;
};
export { PositionsInput };
